import { useWizard } from "react-use-wizard";
import BaseStep from "../../../../../../shared/wizard/steps/baseStep";
import buySteps from "../buySteps";

const WishStep_8 = () => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(buySteps.wishesSteps.step_7);
  };

  const handleNextStep = () => {
    goToStep(buySteps.wishesSteps.step_9);
  };

  return (
    <div>
      <BaseStep
        prevStep={handlePrevStep}
        nextStep={handleNextStep}
        text="Нажимая 'Далее >' подтверждаю стоимость работы риелтора 2.5%"
      />
    </div>
  );
};

export default WishStep_8;
